export const FormStates = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',

  TOUCHED: 'TOUCHED',
  VALID: 'VALID',
  INVALID: 'INVALID',

  VALIDATING: 'VALIDATING',
  SAVING: 'SAVING',
}

export const FormData = {
  value: '',
  newValue: '',
  oldValue: '',
  formState: FormStates.LOADED
}

export const FormFuncs = {
  createFormData: (value) => {
    return {
      value,
      formState: FormStates.LOADED
    }
  }
}